import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_DETAILS.id,
    mainReportId: ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_SUMMARY.id,
    requestParams: {
      consignmentId: rowInfo.row['cardit.consignmentId'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalConsignmentLinkColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'cardit.consignmentId')),
        new DateTimeColumn('Completion date', 'cardit.completionDate'),
        new TextColumn('Final leg route', 'cardit.finalLegRoute'),
        new TextColumn('Final leg conveyance', 'cardit.finalLegConveyance'),
        new DateTimeColumn('Final leg planned departure', 'cardit.finalLegPlannedDepartureDate'),
        new NavigationColumn(new NonZeroNumberColumn('Receptacles', 'cardit.receptacles'), getDetailsTabNavOptions),
        new NonZeroNumberColumn('Weight', 'cardit.weight'),
      ],
    },
    {
      Header: 'RESDIT 14',
      columns: [
        new NonZeroNumberColumn('Any', 'resdit14.any'),
        new NonZeroNumberColumn('YHZ', 'resdit14.yhz'),
      ],
    },
    {
      Header: 'RESDIT 42',
      columns: [
        new NonZeroNumberColumn('YHZ', 'resdit42.yhz'),
      ],
    },
    {
      Header: 'RESDIT 21',
      columns: [
        new NonZeroNumberColumn('Any', 'resdit21.any'),
        new NonZeroNumberColumn('YHZ', 'resdit21.yhz'),
        new NonZeroNumberColumn('FSP', 'resdit21.fsp'),
      ],
    },
  ];
};
